<template>
    <div class="leasingSearchOptionBlock"
         :class="{ 'leasingSearchOptionBlock--open': open }"
    >
        <button type="button"
                class="leasingSearchOptionBlock__header"
                @click="handleClick"
        >
            <span class="leasingSearchOptionBlock__title">
                {{ title }}
            </span>
            <span class="leasingSearchOptionBlock__icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="currentColor"><path d="M441.9 167.3l-19.8-19.8c-4.7-4.7-12.3-4.7-17 0L224 328.2 42.9 147.5c-4.7-4.7-12.3-4.7-17 0L6.1 167.3c-4.7 4.7-4.7 12.3 0 17l209.4 209.4c4.7 4.7 12.3 4.7 17 0l209.4-209.4c4.7-4.7 4.7-12.3 0-17z"/></svg>
            </span>
        </button>
        <div class="leasingSearchOptionBlock__body">
<!--            <div class="leasingSearchOptionBlock__closeContainer">
                <button type="button" class="leasingSearchOptionBlock__close" @click="handleClick">Done</button>
            </div>-->
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        active: {
            type: Boolean,
            default: false,
        },
        open: {
            type: Boolean,
            default: false,
        },
        context: {
            type: String // pass in the context to pass back up to toggle active state in parent
        },
        title: {
            type: String,
        },
        typeSelect: {
            type: Boolean,
            default: false
        },
        parentClass: {
            type: String,
            default: ''
        }
    },
    methods: {
        handleClick() {
            this.$emit('toggle-option', {
                open: this.open,
                context: this.context
            });
        }
    }
}
</script>